// extracted by mini-css-extract-plugin
export var layoutContainer = "_5q-0";
export var layoutContainerNoRounding = "_5q-6";
export var layoutContainerOpen = "_5q-5";
export var layoutContainerResizing = "_5q-1";
export var mainContent = "_5q-2";
export var resizeDivider = "_5q-3";
export var slidePanel = "_5q-4";